import api from 'src/config/api';
import { getJsonResponse } from 'src/utils/ApiUtils';
import Document from 'src/interfaces/api/Document';
import { CollectionResponse } from 'src/interfaces/api/api';
import useAuth from './useAuth';

const useDocument = () => {
  const { fetch } = useAuth();

  const getDocuments = async (ids: string[]): Promise<CollectionResponse<Document>> => {
    const { endpoint, ...options } = api.document.getDocuments(ids);

    const response = await fetch(endpoint, options);

    try {
      return await getJsonResponse<CollectionResponse<Document>>(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  const remove = async (id: string): Promise<Response> => {
    const { endpoint, ...options } = api.document.remove(id);

    const response = await fetch(endpoint, options);

    try {
      return getJsonResponse(response);
    } catch (e) {
      throw new Error(e.message);
    }
  };

  return { getDocuments, remove };
};

export default useDocument;
